module.exports = __webpack_public_path__ + "static/media/vibrant-color-pallete.ea16de0d.png";